<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 text-left mb-3">{{ customer_data.first_name }} tapped the link!</h3>
            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanationPoints"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text" v-html="point"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExplainerLandingPage',

    props: {
        customer_data: {
            type: Object,
            required: true
        },
        wine_data: {
            type: Object,
            required: true
        }
    },

    computed: {
        savings() {
            return (this.wine_data.regular_price - this.wine_data.club_price).toFixed(2);
        },

        explanationPoints() {
            return [
                `She is taken to Barrel Creek's website, where she can view the new release in detail`,
                `Since we're now outside of the SMS environment, the landing page <em>can</em> contain direct promotion of alcohol`,
                `The landing page has multiple pre-defined response options along with the ability to enter a custom quantity. Clicking any option will send a text message back to the winery indicating her interest.`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }
}
</style>
